import {useTranslation} from 'react-i18next';

import {Card} from 'components';
import {SessionHistoryFullStatistic} from 'interfaces';
import {TRANSLATION_KEYS} from 'locale';

import {ActivityMetric} from '../../enums';
import {ActivityMetricsFunnelChart} from '../ActivityMetricsFunnelChart';

const T_KEYS = TRANSLATION_KEYS.USER.ACTIVITY.DASHBOARD;

type Props = {
    statistic: SessionHistoryFullStatistic;
    className?: string;
}

export const ActivityMetricsFunnelChartCard: React.FC<Props> = ({statistic, className}: Props) => {
    const {t} = useTranslation();
    return (
        <Card fullWidth={false} className={className}>
            <div className='tw-ts-sub-header tw-mb-4'>{t(T_KEYS.FUNNEL_CHART.TITLE)}</div>
            <div className='tw-flex'>
                <div className='tw-flex tw-flex-col tw-justify-evenly tw-w-28'>
                    <div>
                        <div>{t(T_KEYS.FUNNEL_CHART.LABELS.TOTAL)}</div>
                        <div className='tw-ts-h2-bold tw-text-default'>{statistic.total.total}</div>
                    </div>
                    <div>
                        <div>{t(T_KEYS.FUNNEL_CHART.LABELS.ANSWERED)}</div>
                        <div className='tw-ts-h2-bold tw-text-default'>{statistic.total.answered}</div>
                    </div>
                    <div>
                        <div>{t(T_KEYS.FUNNEL_CHART.LABELS.SUCCESSFUL)}</div>
                        <div className='tw-ts-h2-bold tw-text-default'>{statistic.total.successful}</div>
                    </div>
                </div>
                <div className='tw-flex-grow tw-my-2 tw-overflow-hidden'>
                    <div className='tw-h-80 tw-min-w-48 tw-max-w-104 tw-mx-auto'>
                        <ActivityMetricsFunnelChart
                            statistic={statistic?.total}
                            metrics={[
                                ActivityMetric.Total,
                                ActivityMetric.Answered,
                                ActivityMetric.Successful
                            ]}
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};